/* ==========================================================================
   VICTORY PATH — vp-animations.js
   GSAP page-load + ScrollTrigger choreography.
   Uses a lightweight custom char/word splitter (no GSAP Club SplitText needed).
   ========================================================================== */
(function () {
  'use strict';

  var EASE_OUT = 'power3.out';
  var STAGGER_CHARS = 0.03;
  var STAGGER_WORDS = 0.08;
  var STAGGER_CARDS = 0.12;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Tiny SplitText replacement ---- */
  function splitChars(el) {
    var text = el.textContent;
    el.setAttribute('aria-label', text);
    el.textContent = '';
    var chars = [];
    // Split into words so the line never breaks mid-word; each word is an
    // inline-block nowrap wrapper that still lets us animate its chars.
    text.split(/(\s+)/).forEach(function (token) {
      if (token === '') return;
      if (/^\s+$/.test(token)) { el.appendChild(document.createTextNode(token)); return; }
      var word = document.createElement('span');
      word.className = 'vp-word';
      word.style.display = 'inline-block';
      word.style.whiteSpace = 'nowrap';
      token.split('').forEach(function (ch) {
        var span = document.createElement('span');
        span.className = 'char';
        span.setAttribute('aria-hidden', 'true');
        span.textContent = ch;
        word.appendChild(span);
        chars.push(span);
      });
      el.appendChild(word);
    });
    return chars;
  }

  function splitWords(el) {
    var text = el.textContent.trim().replace(/\s+/g, ' ');
    el.setAttribute('aria-label', text);
    el.textContent = '';
    var words = [];
    text.split(' ').forEach(function (w, i) {
      if (i > 0) el.appendChild(document.createTextNode(' '));
      var span = document.createElement('span');
      span.className = 'word';
      span.setAttribute('aria-hidden', 'true');
      span.textContent = w;
      el.appendChild(span);
      words.push(span);
    });
    return words;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function init() {
    var hasGSAP = typeof window.gsap !== 'undefined';

    if (!hasGSAP || prefersReduced) {
      // Make sure everything is visible if GSAP missing or reduced motion.
      document.querySelectorAll('[data-reveal]').forEach(function (el) { el.style.opacity = 1; });
      return;
    }

    var gsap = window.gsap;
    if (window.ScrollTrigger) gsap.registerPlugin(window.ScrollTrigger);

    /* ---------- HERO page-load sequence ---------- */
    var hero = document.querySelector('[data-hero]');
    if (hero) {
      var tl = gsap.timeline({ defaults: { ease: EASE_OUT } });
      var eyebrow = hero.querySelector('.hero__eyebrow');
      var heading = hero.querySelector('[data-hero-heading]');
      var cta = hero.querySelector('.hero__cta');

      if (eyebrow) { gsap.set(eyebrow, { opacity: 1 }); tl.from(eyebrow, { opacity: 0, y: 20, duration: 0.6 }); }
      if (heading) {
        gsap.set(heading, { opacity: 1 });
        var chars = splitChars(heading);
        tl.from(chars, { opacity: 0, y: 60, stagger: STAGGER_CHARS, duration: 0.8 }, '-=0.2');
      }
      if (cta) { gsap.set(cta, { opacity: 1 }); tl.from(cta, { opacity: 0, y: 20, duration: 0.5 }, '-=0.3'); }

      // Parallax background
      var bg = hero.querySelector('[data-hero-bg]');
      if (bg && window.ScrollTrigger) {
        gsap.to(bg, {
          yPercent: 18, ease: 'none',
          scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 1 }
        });
      }
    }

    if (!window.ScrollTrigger) {
      document.querySelectorAll('[data-reveal]').forEach(function (el) { gsap.set(el, { opacity: 1 }); });
      return;
    }

    /* ---------- Manifesto word reveal ---------- */
    document.querySelectorAll('[data-manifesto-text]').forEach(function (el) {
      gsap.set(el, { opacity: 1 });
      var words = splitWords(el);
      gsap.from(words, {
        opacity: 0, y: 30, stagger: STAGGER_WORDS, duration: 0.7, ease: EASE_OUT,
        scrollTrigger: { trigger: el, start: 'top 75%', toggleActions: 'play none none none' }
      });
    });

    /* ---------- Generic reveal-on-scroll ---------- */
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      gsap.set(el, { opacity: 1 });
      gsap.from(el, {
        opacity: 0, y: 40, duration: 0.8, ease: EASE_OUT,
        scrollTrigger: { trigger: el, start: 'top 85%', toggleActions: 'play none none none' }
      });
    });

    /* ---------- Staggered groups (product cards etc.) ---------- */
    document.querySelectorAll('[data-reveal-stagger]').forEach(function (group) {
      var items = group.querySelectorAll('[data-reveal-item]');
      if (!items.length) return;
      gsap.set(items, { opacity: 1 });
      gsap.from(items, {
        opacity: 0, y: 50, stagger: STAGGER_CARDS, duration: 0.7, ease: EASE_OUT,
        scrollTrigger: { trigger: group, start: 'top 82%', toggleActions: 'play none none none' }
      });
    });

    /* ---------- Brand-story image parallax ---------- */
    document.querySelectorAll('[data-parallax-img]').forEach(function (img) {
      gsap.fromTo(img, { yPercent: -6 }, {
        yPercent: 6, ease: 'none',
        scrollTrigger: { trigger: img, start: 'top bottom', end: 'bottom top', scrub: 1 }
      });
    });
  }

  ready(init);
})();
